/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/performance_report/settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettings } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettingsProps,
  GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettingsResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettingsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettings = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettings,
  (
    signal: AbortSignal,
    { appGroupId, dsaId, environment }: GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettingsProps
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettingsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/performance_report/settings`,
      "GET",
      { environment },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettingsResult
);
